import { render, staticRenderFns } from "./adminLicense.vue?vue&type=template&id=0bdce1dc&scoped=true"
import script from "./adminLicense.vue?vue&type=script&lang=js"
export * from "./adminLicense.vue?vue&type=script&lang=js"
import style0 from "./adminLicense.vue?vue&type=style&index=0&id=0bdce1dc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdce1dc",
  null
  
)

export default component.exports